<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/project/details', companyId, projectId]">Zum Projekt</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!positions">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Neue Anfrage für Projekt {{ projectNr }} initialisieren</h2>

  <clr-datagrid [(clrDgSelected)]="selectedPositions" >

    <clr-dg-action-bar>
      <div class="btn-group">
        <button type="button" class="btn btn-sm btn-secondary" (click)="addChoosen(selectedPositions)">
          <cds-icon shape="plus"></cds-icon> Für Anfrage auswählen
        </button>
      </div>
    </clr-dg-action-bar>

    <clr-dg-column>Position</clr-dg-column>
    <clr-dg-column>Teil</clr-dg-column>
    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'standard'">Normteil</clr-dg-column>
    <clr-dg-column [clrDgField]="'parent_component'" hidden>Parent</clr-dg-column>
    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnung</clr-dg-column>
    <clr-dg-column [clrDgField]="'material'">Material</clr-dg-column>
    <clr-dg-column>Anzahl</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Position for a Request!</clr-dg-placeholder>

    <clr-dg-row *clrDgItems="let position of filterByTechnology" [clrDgItem]="position">

      <ng-container *ngIf="!position.technology">
        <clr-dg-cell>{{ position.position }}</clr-dg-cell>
        <clr-dg-cell>
          <span *ngIf="position.positions_part != null && position.positions_part > 0">{{ position.positions_part }}</span>
        </clr-dg-cell>
        <clr-dg-cell>{{ position.name }}</clr-dg-cell>
        <clr-dg-cell>
          <span *ngIf="position.positions_part != null && position.positions_part > 0 && position.has_child"><cds-icon shape="bundle" class="is-solid"></cds-icon></span>
        </clr-dg-cell>
        <clr-dg-cell hidden>{{ showParent(position.positions_part, position.technical_drawing) }}</clr-dg-cell>
        <clr-dg-cell>
          <span *ngIf="(position.positions_part != null) ?? '' && (position.has_child)"><cds-icon shape="bundle" class="is-solid"></cds-icon></span>
          {{ position.technical_drawing }}
        </clr-dg-cell>
        <clr-dg-cell>{{ position.material }}</clr-dg-cell>
        <clr-dg-cell>{{ position.number_of_subparts }}</clr-dg-cell>
      </ng-container>

    </clr-dg-row>

    <clr-dg-footer>
      {{ selectedPositions.length }} ausgewählte Positionen
    </clr-dg-footer>
  </clr-datagrid>

  <app-request-form *ngIf="choose.length > 0" [companyId]="companyId" [projectId]="projectId" [choosen]="choose" [isUpdateMode]="false"></app-request-form>
</main>

<pre *ngIf="devMode" class="datepicker-output">
  Choose:
  {{ choose | json }}
</pre>
